import { createAsyncThunk } from '@reduxjs/toolkit';
import { Logger } from 'simple-logging-lib';
import { UNIFIED_NAVIGATION_UI_LOGGER_NAME } from '../../../constants/logging';
import { DataFetchingError } from '../../../errors/DataFetchingError';
import { getPortalId } from '../../../utils/getPortalId';
import { invalidateNavConfigCache } from '../../../config/getConfig';
import { navConfigCache } from '../../../config/cache';
export const invalidateNavConfig = async portalId => {
  // Remove config from local storage
  navConfigCache.delete();
  // Invalidate nav config on the backend
  await invalidateNavConfigCache(portalId);
};
export const invalidateNavConfigThunk = createAsyncThunk('invalidateNavConfig/invalidateNavConfig', async (_, {
  rejectWithValue
}) => {
  const logger = Logger.getLogger(UNIFIED_NAVIGATION_UI_LOGGER_NAME);
  const portalId = getPortalId();
  if (!portalId) {
    return rejectWithValue();
  }
  try {
    await invalidateNavConfig(portalId);
  } catch (error) {
    if (error instanceof Error && error.message === 'Navconfig is null') {
      logger.error(error);
      return rejectWithValue();
    }
    const requestError = error;
    logger.error(new DataFetchingError('Failed to update optins status', {
      statusCode: requestError.status,
      cause: requestError
    }));
    return rejectWithValue();
  }
});